import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircle2, ShieldCheck, Zap } from "lucide-react";
import equipe from "../imagem/equipe.jpg";

function About() {
  return (
    <section id="sobre" className="about-luxury-transparent py-20">
      <Container>
        <Row className="align-items-center gy-5">
          <Col md={6} data-aos="fade-right" data-aos-duration="600">
             <h6 className="text-gold text-uppercase fw-bold mb-3 ls-3">Legado Henrimack</h6>
             <h2 className="section-title-premium mb-4">Engenharia de Elite para <span className="highlight-gold">Softwares Sob Medida</span></h2>
             
             <p className="lead-soft mb-4">
               Diferente de agências comuns, a <strong>Henrimack</strong> nasceu no coração da operação. 
               Especializamo-nos em sistemas críticos onde a precisão absoluta é a única opção.
             </p>
             
             <p className="text-gray-sub mb-10">
               Desde o <strong>SGE Pro</strong> até automações industriais complexas, entregamos softwares 
               que não apenas funcionam, mas aceleram o crescimento do seu negócio através de 
               interfaces ultra-fluidas e segurança blindada.
             </p>

             <Row className="gy-4">
               <Col sm={6} className="feature-mini-elite d-flex align-items-center gap-3">
                 <div className="icon-gold-box"><Zap size={18} /></div>
                 <span className="small fw-bold text-gray-sub">Alta Performance</span>
               </Col>
               <Col sm={6} className="feature-mini-elite d-flex align-items-center gap-3">
                 <div className="icon-gold-box"><ShieldCheck size={18} /></div>
                 <span className="small fw-bold text-gray-sub">Segurança Blindada</span>
               </Col>
               <Col sm={6} className="feature-mini-elite d-flex align-items-center gap-3">
                 <div className="icon-gold-box"><CheckCircle2 size={18} /></div>
                 <span className="small fw-bold text-gray-sub">Sincronia Operacional</span>
               </Col>
             </Row>
          </Col>
          <Col md={6} data-aos="fade-left" data-aos-duration="400">
             <div className="about-media-wrapper">
                <div className="media-accent-gold"></div>
                <img
                  src={equipe}
                  alt="Equipe Henrimack"
                  className="img-fluid about-img-premium"
                />
             </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .about-luxury-transparent {
          background: transparent;
          color: #fff;
          position: relative;
        }

        .ls-3 { letter-spacing: 3px; font-size: 0.75rem; }
        .text-gray-sub { color: #888; }
        .lead-soft { font-size: 1.25rem; color: #b0b0b0; line-height: 1.8; }

        .icon-gold-box {
           background: rgba(228, 168, 122, 0.1);
           color: var(--elite-gold);
           width: 38px; height: 38px;
           display: flex; align-items: center; justify-content: center;
           border-radius: 10px;
        }

        .about-media-wrapper {
           position: relative;
           padding: 1rem;
        }

        .media-accent-gold {
           position: absolute; top: 0; left: 0; width: 100%; height: 100%;
           border: 1px solid rgba(228, 168, 122, 0.2);
           border-radius: 30px;
           z-index: -1;
           transform: translate(15px, 15px);
        }

        .about-img-premium {
           border-radius: 30px;
           box-shadow: 0 50px 100px rgba(0,0,0,0.7);
           filter: grayscale(0.1) contrast(1.1);
           transition: all 0.6s ease;
        }

        .about-img-premium:hover {
           filter: grayscale(0);
           transform: scale(1.02);
        }
      `}</style>
    </section>
  );
}

export default About;
